/**
 * The colours a class can be given.
 *
 * Deliberately a small, fixed, muted set rather than a free colour picker: six
 * choices are enough to tell a week's classes apart, they are all legible against
 * both the light and dark surfaces, and a fixed list keeps the schedule looking
 * composed rather than assembled at random.
 */
export const CLASS_COLORS = [
  '#6b4f8a', // plum
  '#2f7d6a', // pine
  '#b4632b', // amber
  '#37618f', // slate blue
  '#8a3c5c', // wine
  '#5c6b2f', // olive
] as const;

export const DEFAULT_CLASS_COLOR = CLASS_COLORS[0];

/** Cycles the palette so consecutively added classes look different. */
export function nextClassColor(existingCount: number): string {
  return CLASS_COLORS[existingCount % CLASS_COLORS.length] as string;
}

/** Names for the swatch labels, so the picker is usable without sight of it. */
export const CLASS_COLOR_NAMES: Record<string, string> = {
  '#6b4f8a': 'plum',
  '#2f7d6a': 'pine',
  '#b4632b': 'amber',
  '#37618f': 'blue',
  '#8a3c5c': 'wine',
  '#5c6b2f': 'olive',
};

export function colorName(hex: string): string {
  return CLASS_COLOR_NAMES[hex.toLowerCase()] ?? hex;
}
